import axios from 'axios';

// Use environment variable or relative path (for single container deployment)
// When frontend and backend are in same container, use relative '/api'
const API_URL = process.env.REACT_APP_API_URL || '';

// Base URL - if API_URL is empty, use relative path '/api'
const baseURL = API_URL ? (API_URL.endsWith('/api') ? API_URL : `${API_URL}/api`) : '/api';

const api = axios.create({
  baseURL: baseURL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// User API
export const userService = {
  register: (userData) => api.post('/users/register', userData),
  login: (email, password) => api.post('/users/login', { email, password }),
  getMe: () => api.get('/users/me'),
  updateProfile: (userData) => api.put('/users/me', userData),
  getAllUsers: () => api.get('/users')
};

// Arisan API
export const arisanService = {
  create: (arisanData) => api.post('/arisan', arisanData),
  getAll: () => api.get('/arisan'),
  getById: (id) => api.get(`/arisan/${id}`),
  update: (id, arisanData) => api.put(`/arisan/${id}`, arisanData),
  delete: (id) => api.delete(`/arisan/${id}`),
  drawRecipient: (id) => api.post(`/arisan/${id}/draw`),
  addMember: (id, userId) => api.post(`/arisan/${id}/members`, { userId }),
  removeMember: (id, userId) => api.delete(`/arisan/${id}/members/${userId}`),
  setRecipient: (id, userId) => api.post(`/arisan/${id}/recipients`, { userId }),
  updateRecipient: (id, recipientIndex, data) => api.put(`/arisan/${id}/recipients/${recipientIndex}`, data),
  deleteRecipient: (id, recipientIndex) => api.delete(`/arisan/${id}/recipients/${recipientIndex}`)
};

// Member API
export const memberService = {
  getByArisan: (arisanId) => api.get(`/members/arisan/${arisanId}`),
  getById: (id) => api.get(`/members/${id}`),
  add: (memberData) => api.post('/members', memberData),
  remove: (id) => api.delete(`/members/${id}`),
  updateStatus: (id, status) => api.put(`/members/${id}`, { status })
};

// Transaction API
export const transactionService = {
  recordContribution: (data) => api.post('/transactions/contribution', data),
  recordDistribution: (data) => api.post('/transactions/distribution', data),
  getByArisan: (arisanId) => api.get(`/transactions/arisan/${arisanId}`),
  getByMember: (memberId) => api.get(`/transactions/member/${memberId}`),
  getById: (id) => api.get(`/transactions/${id}`),
  update: (id, data) => api.put(`/transactions/${id}`, data),
  getSummary: (arisanId) => api.get(`/transactions/summary/${arisanId}`)
};

// Export apiClient untuk service yang lain
export const apiClient = api;

export default api;
